import React, { useState } from "react";
import { motion } from "framer-motion";
import { FiPenTool } from "react-icons/fi";
import { TbApps } from "react-icons/tb";
import { HiOutlineTemplate } from "react-icons/hi";
import { BsBoxArrowUpRight } from "react-icons/bs";

const item = {
  hidden: { opacity: 0, y: 24, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.55 } },
};

function PortfolioCard({ project }) {
  const p = project;
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <motion.div
      variants={item}
      whileHover={{ y: -4 }}
      className="relative rounded-2xl bg-gray-50 border border-gray-200 shadow-sm overflow-hidden py-2 px-4 max-w-[93%] mx-auto"
    >
      {/* Image area: centered, rounded top corners */}
      <a href={`/projects/${p.id}`} className="block group">
        <div className="relative w-full h-[19rem] sm:h-[19rem] bg-white/90 rounded-t-2xl overflow-hidden flex items-center justify-center">
          {/* Skeleton placeholder */}
          {!imgLoaded && (
            <div className="absolute inset-0 bg-gray-200 animate-pulse" />
          )}
          <img
            src={p.image}
            alt={p.title}
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`max-w-full rounded-lg max-h-full object-contain transition-transform duration-500 group-hover:scale-[1.01] ${imgLoaded ? "opacity-100" : "opacity-0"}`}
          />
        </div>
      </a>
      {/* Meta with chips below image */}
      <div className="p-4">
        <div className="flex flex-wrap gap-2 mb-3">
          {[p.category, ...(p.tech || [])].slice(0, 3).map((tag, idx) => {
            const icon =
              idx === 0 ? (
                <FiPenTool />
              ) : idx === 1 ? (
                <TbApps />
              ) : (
                <HiOutlineTemplate />
              );
            const isCategory = idx === 0;
            const chipClass = isCategory
              ? "bg-teal-500 text-white border-teal-500"
              : "bg-teal-100 text-teal-800 border-teal-200";
            const iconClass = isCategory ? "text-white" : "text-teal-700";
            return (
              <span
                key={`${p.id}-chip-${idx}`}
                className={`inline-flex items-center gap-2 text-[12px] font-semibold px-3 py-1 rounded-full ${chipClass} shadow-sm`}
              >
                <span className={iconClass}>{icon}</span>
                {tag}
              </span>
            );
          })}
        </div>
        <a href={`/projects/${p.id}`} className="font-bold text-gray-900 leading-snug hover:underline">{p.title}</a>
        <p className="text-xs text-gray-500 mt-0.5">{p.category}</p>
      </div>
      {/* External live link button */}
      {p.link && (
        <a
          href={p.link}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute bottom-3 right-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-white border border-gray-200 shadow hover:shadow-md transition"
          aria-label="Open live project"
          title="Open live project"
        >
          <BsBoxArrowUpRight className="text-gray-700" />
        </a>
      )}
    </motion.div>
  );
}

export default PortfolioCard;
